import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate, useLocation } from 'react-router-dom';

export default function Completetask_details() {
    const navigate = useNavigate();
    const [listFilesTask, setListFilesTask] = useState([]);
    const [listTskMems, setListTskMems] = useState([]);
    const [userIsCreator, setuserIsCreator] = useState(false);
    useEffect(() => {
        var userid = localStorage.getItem('member_id');
        var pr_key = localStorage.getItem('taskid');
        var pid = localStorage.getItem('taskproid');


        let obj = {
            primary_key: pr_key
        };

        console.log(obj);

        fetch('gettskDetails.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // IMPORTANT
            .then(jsonString => {
                console.log(jsonString);

                const name = jsonString[0].tsk_proname;
                $('#pro_info').text(name ? name.toUpperCase() : 'Not Available');

                let tskname = jsonString[0].taskname;
                $('#tskname').text(tskname ? tskname.toUpperCase() : 'Not Available');

                const prodate = jsonString[0]?.assigneDate ?? 'Not available';
                $('#pro_date_info').text('Date : ' + prodate);

                $('#tsk_details').text(jsonString[0]?.task_details ?? 'Not available');
                $('#edittextarea').val(jsonString[0]?.task_details ?? 'Not available');

                const assignname = jsonString[0].assigneBy;
                $('#asign_name').text(assignname ? assignname.toUpperCase() : 'Not available');

                const assigndate = jsonString[0].assigneDate;
                $('#asign_date').text(assigndate ? assigndate : 'Not available');

                $('#assignbydid').val(jsonString[0]?.assignById ?? "not available");

                const tskstatus = jsonString[0].tsk_status;
                $('#tsk_status').text(tskstatus ? tskstatus.toUpperCase() : "not available");

                var timerm = jsonString[0]?.assign_time ?? '0:0';
                var arr = timerm.split(':');
                var totaltime = arr[0] + ' Hours - ' + arr[1] + ' minutes';
                $('#tsk_time').text(totaltime);

                var crtid = jsonString[0].assignById;
                if (String(userid) === String(crtid)) {
                    setuserIsCreator(true);
                } else {
                    $('#reactivebtn').css('display', 'none');
                    setuserIsCreator(false);
                }

                var wordkhrs = jsonString[0]?.work_time ?? '0:0';
                var warr = wordkhrs.split(':');
                var totaltimew = warr[0] + ' Hours - ' + warr[1] + ' minutes';
                $('#worktsk_time').text(totaltimew);

                var tskid = jsonString[0]?.id ?? 'Not found';
                var filearr = jsonString[0].files;

                setListFilesTask(filearr);

                if (tskid !== 'Not found') {
                    addTeamFunction(tskid);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });

    }, [])

    function addTeamFunction(tskid) {
        var obj = {
            tsk_id: tskid
        };

        fetch('get_tsk_member.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.text()) // handle both JSON and 'fail'
            .then(response => {
                if (response !== 'fail') {
                    try {
                        const jsonData = JSON.parse(response); // safe parsing

                        console.log(jsonData);
                        setListTskMems(jsonData);

                    } catch (e) {
                        console.error("JSON Parse Error:", e);
                        showAlert("Invalid data from server");
                    }
                } else {
                    showAlert("Cannot find any member for this task");
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function retruntolist() {
        let returntomylist = localStorage.getItem('redirectto')
        let returnToAdminlist = localStorage.getItem('adminredirectto')
        if (returntomylist == 'mytask') {
            localStorage.setItem('redirectto', 'no');
            navigate('/redirect_mytask');
        } else if (returnToAdminlist == 'admintask') {
            localStorage.setItem('adminredirectto', 'no');
            navigate('/admin_mytask');
        } else {
            var memtype = localStorage.getItem('user_position')
            if (memtype === 'Member') {
                localStorage.setItem('initialpage', 'member_task');
            } else {
                localStorage.setItem('initialpage', 'task');
            }

            navigate('/redirect_task');
        }
    }

    function openReactivePop() {
        $('#reactivetsk').css('display', 'block');
    }
    function clsoeReactivetsk() {
        $('#reactivetsk').css('display', 'none');
    }

    function reactivetask() {
        const today = new Date().toISOString().split('T')[0];
        var pr_key = localStorage.getItem('taskid');

        var obj = {
            pr_key: pr_key,
            comdate: today
        };

        console.log(obj);

        fetch('reactive_task.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.text()) // IMPORTANT (because PHP returns plain text)
            .then(result => {
                console.log(result);

                if (result !== 'fail') {
                    localStorage.setItem('initialpage', 'task');
                    navigate('/redirect_task');
                } else {
                    showAlert('Cannot remove member.');
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }

    return (
        <div>
            <div className='fullwidth'>
                <section className='mainsection border-bottom'>
                    <div className='max-container'>
                        <div className='headpart'>

                            <div className='vl_dsh_one_half'>
                                <div className='fullwidth topbackBar'>
                                    <button className='back_btn' onClick={retruntolist}><i class="ri-arrow-left-line"> Back</i></button>
                                </div>
                                <p className='top_info' id="pro_info">Company Name<span><i class="ri-arrow-right-line"></i></span><span id="tskname"></span></p>
                            </div>
                            <div className='vl_dsh_one_half'>
                                <p className='top_info text_right' id="pro_date_info">Date : 02/05/2025</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='mainsection'>
                    <div className='max-container'>

                        <div className='vl_dsh_two_third'>
                            <div className='inforow'>
                                <h3 id="tskheading" >Details </h3>
                                <button className='workbutton' id="reactivebtn" onClick={openReactivePop}>Re-active</button>

                                <p className='hilighttext mt20' id="tsk_details"></p>


                            </div>
                            <div className='inforow'>
                                <h3>Assigned By</h3>
                                <p id="asign_name"></p>
                                <input type="hidden" id="assignbydid" />
                            </div>
                            <div className='inforow'>
                                <h3>Assigned Date</h3>
                                <p id="asign_date"></p>
                            </div>
                            <div className='inforow'>
                                <h3>Status</h3>
                                <p id="tsk_status"></p>
                            </div>
                            <div className='inforow'>
                                <h3>Time Frame</h3>
                                <p id="tsk_time"></p>
                            </div>
                            <div className='inforow'>
                                <h3>Worked</h3>
                                <p id="worktsk_time"></p>
                            </div>

                            <div className='inforow'>
                                <h3 className='fullwidth'>Assigned To</h3>

                                <p className='fullwidth tskmemlist' id="asign_name_to">
                                    {Array.isArray(listTskMems) && listTskMems.map((item, index) => (
                                        <span>
                                            <span>{item.member_name}</span>

                                        </span>
                                    ))}
                                </p>

                            </div>

                            <h3 className='file_list_area_heading'>Files</h3>
                            <div className='file_list_area'>
                                {listFilesTask.map((item, index) => (
                                    <div className='attachmentprev' key={index}>
                                        <span><a href={item.link} target="_blank"><img src={item.link} /></a></span>
                                        <p><a href={item.link} target="_blank">{item.name.toUpperCase()}{item.type.toUpperCase()}</a></p>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='vl_dsh_one_third'>

                        </div>
                    </div>
                </section>
            </div>

            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>

            <div className='vl_dsh_popup' id="reactivetsk">
                <div className='memlistareashort'>

                    <div className='memlistcontainer'>
                        <p>Are you sure you want to re-active this task?</p>
                        <div className='vl_dsh_buttonholder'>
                            <button onClick={reactivetask}>Yes</button>
                            <button className='closebtn' onClick={clsoeReactivetsk}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
